(function () {
    'use strict';

    angular.module('swif.openbase')
        .config(route)
        .factory('swifOpenbaseSmsTemplateService', swifOpenbaseSmsTemplateService)
        .controller('OpenbaseSmsTemplateController', OpenbaseSmsTemplateController)
        .controller('OpenbaseEditSmsTemplateController', OpenbaseEditSmsTemplateController)
        .directive('panelSmsTemplate', panelSmsTemplate);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/sms_template/table_view', {
            templateUrl: 'partials/openbase/sms_template_table_view.html',
            controller: 'OpenbaseSmsTemplateController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when('/configuration/sms_template/explorer_view', {
            templateUrl: 'partials/openbase/sms_template_explorer_view.html',
            controller: 'OpenbaseSmsTemplateController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    function OpenbaseSmsTemplateController($scope, swifModule, swifOpenbaseSmsTemplateService, swifOpenbaseService, dataService) {
        'ngInject';
        $scope.modules = swifOpenbaseSmsTemplateService.modules;
        swifOpenbaseSmsTemplateService.createCollection().then(function (collection) {
            $scope.smsTemplates = collection;
        });
        $scope.swifModule = swifModule;
        $scope.callback = swifOpenbaseSmsTemplateService.callback;
        $scope.preValidate = swifOpenbaseSmsTemplateService.preValidate;
        $scope.preModal = swifOpenbaseSmsTemplateService.preModal;

        let moveTemplate = function(move, currentTemplate, index) {
            // Record the movement and apply it dynamically to the view
            dataService.callKw('sms_template', move, [currentTemplate.id])
            .then((results) => {
                // Get the moved template
                let templateToMove = _.remove($scope.smsTemplates.items, (template) => template.id === currentTemplate.id);
                // Move it by changing the model
                swifOpenbaseService.utils.insertItemInArray($scope.smsTemplates.items, index, templateToMove[0]);
            });
        };

        $scope.goUp = function (templateToGoUp, index) {
            let indexUp = index-1;
            moveTemplate('move_up', templateToGoUp, indexUp);
        };

        $scope.goDown = function (templateToGoDown, index) {
            let indexDown = index+1;
            moveTemplate('move_down', templateToGoDown, indexDown);
        };
    }

    function swifOpenbaseSmsTemplateService($q, swif) {
        'ngInject';
        var service = {};
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'sequence', 'ASC');
            return swif.collections.createOrUpdate('smsTemplates', 'sms_template', filter);
        };

        service.getCollection = function () {
            return swif.collections.getCollection('smsTemplates');
        };

        service.preValidate = function (data) {
            return service.getCollection().preValidate(data);
        };

        service.preModal = function (data) {
            if (data.action.id == 'add') {
                var filter = { fields: ['model', 'id', 'name'] };
                // Allow these models for the select dropdown
                swif.data.addFilter(filter, 'model',"in", ["openstc.ask", "project.project", "project.task"])
                swif.data.get('model', undefined, filter).then(function (response) {
                    data.model.modelChoices = response;
                });
                data.model.model_id = [];
            }
        }

        service.callback = function (data) {
            // Update table data
            service.createCollection();
        }

        service.modules = swif.module.modules;
        return service;
    }

    function OpenbaseEditSmsTemplateController($scope, swif) {
        'ngInject';
        console.log('OpenbaseEditSmsTemplateController');
        $scope.showHelp = false;
        $scope.form.$waitAction = !swif.settings.app.features.sms;

        $scope.filters = $scope.model.filter;
        $scope.preview = {};
        $scope.updatePreview = function ($value) {
            if ($scope.preview.example && $scope.model.model_id) {
                // Call render_template for each field with mako expressions ${expr}
                ['content', 'name', 'to'].forEach(renderField);
            }
        };

        function renderField(fieldName) {
            swif.data.callKw(
                'sms_template',
                'render_template',
                [$scope.model[fieldName], $scope.model.model, $scope.preview.example[0]]
            ).then(function (values) {
                $scope.preview[fieldName] = values;
            });
        };

        // Force `project.project` & `project.task` model to match `intervention` & `task` content type
        // This is because there's two `project.project` declaration on `default.json` and it can match the wrong one.
        $scope.updateModel = function(value) {
            $scope.model.model = value.model;
            if ($scope.model.model == 'project.project') {
                $scope.templateTargetType = 'intervention';
            } else if ($scope.model.model == 'project.task') {
                $scope.templateTargetType = 'task';
            } else {
                $scope.templateTargetType  = swif.settings.getContentTypeFromModel($scope.model.model).id;
            }
        };

        $scope.updateModel($scope.model);

        // Checks model name unicity
        $scope.$watch('model.name', function (newVal, oldVal) {
            if (!newVal || newVal == oldVal) {
                return;
            }

            var params = {
                fields: ['name'],
                domain: [
                    ['name', '=', newVal]
                ]
            };

            // Exclude current template
            if ($scope.action.id === 'edit' && $scope.model.id) {
                params.domain.push(['id', '!=',  $scope.model.id]);
            }

            // Checks if the searched template name already exist
            swif.data.searchRead('sms_template', params).then(function (matchedModelName) {
                $scope.form['model.name'].$setValidity(
                    'alreadyUsed',
                    matchedModelName.ids.length === 0  // Validate the form if there is no match
                );
            });
        });
    };

    // will be used in the right side of the explorer view
    function panelSmsTemplate(swif) {
        'ngInject';
        var directive = swif.panel.create_directive('sms_template');
        directive.templateUrl = 'partials/openbase/panel-sms-template.html';
        return directive;
    };

})();
